export { default } from "./YAxisTick";
